import { IncompleteReasonsApiService } from '@common/ApiService'
const INCOMPLETEREASON_ERROR = 'INCOMPLETEREASON_ERROR'
const INCOMPLETEREASON_SUCCESS = 'INCOMPLETEREASON_SUCCESS'

export const state = {
  incompleteReasons: [],
  error: null,
}

export const getters = {
  incompleteReasonsOptions: (state) => {
    return state.incompleteReasons
  },
}

export const mutations = {
  [INCOMPLETEREASON_SUCCESS](state, data) {
    state.incompleteReasons = data
    return state
  },
  [INCOMPLETEREASON_ERROR](state, data) {
    state.error = data
    return state
  },
}

export const actions = {
  getIncompleteReasons({ commit }) {
    return IncompleteReasonsApiService.get()
      .then((response) => {
        commit(INCOMPLETEREASON_SUCCESS, response.data)
      })
      .catch((e) => commit(INCOMPLETEREASON_ERROR, e))
  },
}
